import { render, staticRenderFns } from "./People.vue?vue&type=template&id=3701c598&scoped=true"
var script = {}
import style0 from "./People.vue?vue&type=style&index=0&id=3701c598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701c598",
  null
  
)

export default component.exports